import { createSelector } from 'reselect';

export const selectCollectionItemEvents = createSelector(
  ({ collections }) => collections,
  ({ collectionItemsEvents }) => collectionItemsEvents,
);
